import { InjectionToken } from '@angular/core';
import { IAsset, IReportContext, IReportDialogOptions, ReportHistoryEventType } from '@phx-erp/shared';

export interface IReportTriggerExecution {
    executeReportWithTriggers(
        reportContext: IReportContext,
        action: ReportHistoryEventType,
        // actionSwitchHandler?: ActionSwitchHandler
    ): Promise<void | IAsset[]>;
    /**
     * Opens the host print/preview dialog. Resolves when the modal closes.
     */
    showPreviewDialog(reportContext: IReportContext, dialogOptions?: IReportDialogOptions): Promise<void>;
}

export const REPORT_TRIGGER_EXECUTION = new InjectionToken<IReportTriggerExecution>(
    'REPORT_TRIGGER_EXECUTION'
);
